var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-header"},[_c('img',{staticClass:"rumy-logo",attrs:{"src":"/assets/home/logo.png?v=2"}}),_c('div',{staticClass:"main-comment noto-small"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }